import { Card, CardContent } from "@material-ui/core";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import i18n from "../../i18n";
import AuthService from "../../session/AuthService";
import FriendPostCard from "./FriendPostCard";

class FriendPosts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNo: 0,
      postList: [],
    };
    this.pageNo = this.pageNo.bind(this);
    this.likeStatus = this.likeStatus.bind(this);
  }

  componentDidMount() {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
    this.setState({ postList: this.props.userPostList });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userPostList !== this.props.userPostList) {
      this.setState({ postList: this.props.userPostList });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <>
        {this.state.postList &&
          this.state.postList.length > 0 &&
          this.state.postList.map((post, index) => (
            <FriendPostCard
              data={post}
              userLikeType={post.userlikeType}
              likestatusUpdate={this.likeStatus}
            ></FriendPostCard>
          ))}
        {this.props.noMoreState ? (
          <div className="networkDetailsBtn" style={{ marginTop: "12px" }}>
            <button className="networkSeeMore" onClick={this.pageNo}>
              {t("See more")}
            </button>
          </div>
        ) : !this.props.blockStatus ? (
          <div style={{ textAlign: "center", marginTop: "12px" }}>
            <Card>
              <CardContent>
                <center>
                  <p style={{ textAlign: "center", marginTop: "12px" }}>
                    {t("No More Post Available")}
                  </p>
                </center>
              </CardContent>
            </Card>
            {/* <h6>No More Post Available</h6> */}
          </div>
        ) : (
          <></>
        )}
        {/* {this.state.postList.length === 0 && (
          <Card>
            <CardContent>
              <center>
                <p style={{ textAlign: "center", marginTop: "12px" }} onClick={this.pageNo}>{t("No Post Available")}</p>
              </center>
            </CardContent>
          </Card>
        )} */}
      </>
    );
  }

  pageNo() {
    this.props.loadMorePosts();
  }

  likeStatus = (result, userLike) => {
    this.props.likeStatus(result, userLike);
  };
}

const mapStateToProps = function (state) {
  return {};
};

export default connect(
  mapStateToProps,
  null
)(withTranslation()(withRouter(FriendPosts)));
